import fitty from "fitty";

window.addEventListener("load", () => {
  fitty(".typ-fitty", {
    minSize: 48,
    maxSize: 450,
  });
});
